<template>
  <v-card flat>
    <v-card-title>
      {{ playlist.title }}
    </v-card-title>
    <v-card-subtitle>
      Total videos - {{ itemCount }}
    </v-card-subtitle>
    <v-row class="d-md-flex d-block">
      <v-col>
        <v-responsive :aspect-ratio="16/9">
          <youtube
            width="100%"
            height="100%"
            :video-id="currentVideo"
          />
        </v-responsive>
        
        <v-card-title
          v-text="currentVideoTitle"
        />
        <v-card-subtitle
          v-text="currentVideoChannel"
        />
      </v-col>
      <v-col cols="md-4">
        <v-card
          flat
          height="600px"
          class="scrollbar-hidden overflow-y-auto"
        >
          <v-list nav>
            <v-list-item-group
              value="true"
              active-class="primary--text text--accent"
            >
              <!-- this solution (update video tite) is dumb but it works, I wish it was simpler -->
              <v-list-item
                v-for="video in videoIDs"
                :key="video.id"
                @click="currentVideo=video.id, currentVideoTitle=video.title, currentVideoChannel=video.channel"
              >
                <v-list-item-content>
                  <v-row no-gutters>
                    <v-col cols="auto">
                      <v-img
                        :src="video.thumbnail.url"
                        min-width="70px"
                        max-width="70px"
                        class="mr-2"
                      />
                    </v-col>
                    <v-col
                      cols="8"
                      align-self="center"
                    >
                      <v-list-item-title v-text="video.title" />
                      <v-list-item-subtitle v-text="video.channel" />
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>

export default {
  props: {
    id: {
      type: String,
      default: null
    },
  },
  data(){
    return {
      playlist: {},
      itemCount: null,
      items: [],
      channel: null,
      currentVideo: null,
      currentVideoTitle: null,
      currentVideoChannel: null,
      shop: {}
    }
  },
  computed: {
    videoIDs(){
      return this.items.map(v=>{
        return{
          id: v.snippet.resourceId.videoId,
          thumbnail: v.snippet.thumbnails.standard || {},
          title: v.snippet.title,
          channel: v.snippet.channelTitle
        } 
      })
    },
    featuredPlaylist(){
      return (this.shop.youtube || {}).featured_playlist
    }
  },
  watch:{
    featuredPlaylist(){
      this.fetch()
    }
  },
  mounted(){
    this.fetch()
  },
  methods:{
    async fetch(){
      this.shop = await this.api.get('/shop/status')
      let playlistID = this.id || this.featuredPlaylist
      if (playlistID) {
        let data = await this.api.get(`/youtube/playlist/${playlistID}`)
        if (data) {
          this.playlist = data.playlist.snippet
          this.itemCount = data.playlist.contentDetails.itemCount
          this.items = data.playlistItems.items
          this.channel = data.channel
          this.currentVideo = this.videoIDs[0].id
          this.currentVideoTitle = this.videoIDs[0].title
          this.currentVideoChannel = this.videoIDs[0].channel
        }
      }
    }
  },
}
</script>

<style scoped>
    .video-size {
        width: 100px;
    }
    .scrollbar-hidden::-webkit-scrollbar {
      display: none;
    }
    .scrollbar-hidden {
      -ms-overflow-style: none;
      scrollbar-width: none; /* Firefox */
    }
</style>